/** Format a metersPerUnit value as "X km | m | cm | mm" with sensible precision. */
export function formatMetersPerUnit(metersPerUnit: number): string {
  if (metersPerUnit >= 1000) return `${(metersPerUnit / 1000).toFixed(3)} km`;
  if (metersPerUnit >= 1) return `${metersPerUnit.toFixed(3)} m`;
  if (metersPerUnit >= 0.01) return `${(metersPerUnit * 100).toFixed(2)} cm`;
  return `${(metersPerUnit * 1000).toFixed(2)} mm`;
}
